import { render, staticRenderFns } from "./IncidentsTemplate.vue?vue&type=template&id=38f1e1b5&"
import script from "./IncidentsTemplate.vue?vue&type=script&lang=js&"
export * from "./IncidentsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports